import { IIconProps, makeStyles } from '@fluentui/react';

export const exportIcon: IIconProps = {
  iconName: 'Go',
  styles: {
    root: {
      fill: 'white',
      marginRight: 10,
    },
  },
};

export const useStyles = makeStyles(() => ({
  description: {
    marginTop: 10,
  },
}));
